import React, { useEffect, useRef, useState } from "react";
export const PimcoreImage = (props) => {
    const [id, setId] = useState("pimcore_image_" + Math.floor(Math.random() * 1000));
    const [editable, setEditable] = useState(null);
    const [ref, setRef] = useState(null);
    /**
     * Need to decouple our callback from the mutation observer itself.
     * Otherwise, all components this calls back to will work with stale state
     * which is a hassle to avoid
     */
    const mutationCallback = () => {
        if (editable) {
            props.onChange(editable.getValue());
        }
    };
    const mutationCallbackRef = useRef(mutationCallback);
    mutationCallbackRef.current = mutationCallback;
    useEffect(() => {
        // @ts-ignore
        let editable = new pimcore.document.editables.image(id, "image", [], props.data);
        editable.setRealName("reactimage");
        editable.setInDialogBox(null);
        editable.render();
        setEditable(editable);
    }, []);
    useEffect(() => {
        if (ref === null || editable === null) {
            return;
        }
        // @ts-ignore
        const observer = new MutationObserver(() => mutationCallbackRef.current());
        observer.observe(ref, { attributes: true, childList: true, subtree: true });
        return () => {
            observer.disconnect();
        };
    }, [ref, editable]);
    return (React.createElement("div", { style: { width: "500px", height: "250px" }, id: id, ref: setRef }));
};
